export const stream = {
    streamConfig: "Stream Config",
    accumulateDeposit: "Accumulate Deposit",
    create:"Create",
    update:"Update",
    streamer:"Streamer",
    streamer:{
      topic:"Streamer",
      create:"Create",
      id:"Id",
      operatorId:"Operator Id",
      name:"Name",
      imageUrl:"Image Url",
      description:"Description",
      isActive:"Is Active",
      createdAt:"Create At",
      updatedAt:"Update At"
    },
    streaming:{
      topic:"Streaming",
      create:"Create",
      id:"Id",
      operatorId:"Operator Id",
      streamerId:"Streamer Id",
      streamingName:"Streaming Name",
      streamingDetail:"Streaming Detail",
      streamingUrl:"Streaming Url",
      streamingKey:"Streaming Key",
      playerThumbnailUrl:"Player Thumbnail Url",
      isActive:"Is Active",
      createdAt:"Created At",
      updatedAt:"Updated At",
      }
  };
  